var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FlagIcon"},[(_vm.countryCode === 'DK')?_c('DKFlag'):_vm._e(),(_vm.countryCode === 'EN')?_c('ENFlag'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }